<div class="fx-column">
  <div class="fx-row align-items-center justify-content-between">
    <app-back></app-back>
  </div>
  <div class="fx-row align-items-center justify-content-between">
    <div class="fx-row align-items-center justify-content-start">
      <div class="fx-column">
        <span class="page-title">{{ 'INTEGRATIONS.CRAWL_URLS.TITLE' | translate }}</span>
        <span class="page-subtitle">{{ 'INTEGRATIONS.CRAWL_URLS.DESCRIPTION' | translate }}</span>
      </div>
    </div>
  </div>
  <mat-divider class="mv-20"></mat-divider>
  @if (!loading && done) {
    @if (executions.length === 0) {
      <app-empty-placeholder class="fx-flex" [offset]="125"
        [title]="'INTEGRATIONS.CRAWL_URLS.NO_EXECUTION_TITLE'"
        [message]="'INTEGRATIONS.CRAWL_URLS.NO_EXECUTION_MESSAGE'"></app-empty-placeholder>
    } @else {
    <mat-card class="p-0">
      <div class="fx-row align-items-center justify-content-between p-16">
        <div class="fx-row align-items-center justify-content-start">
          <div class="fx-row fw-wrap align-items-baseline justify-content-start ml-10">
            <app-animated-number [value]="paginator.totalDocs" [class]="'bold main'"></app-animated-number>
            &nbsp;
            <span class="text"><span class="bold main">{{
                ((paginator.totalDocs > 1
                  ? 'INTEGRATIONS.CRAWL_URLS.URLS'
                  : 'INTEGRATIONS.CRAWL_URLS.URL')
                  | translate
                )
              }}</span> {{ ('UTILS.MATCHING' | translate).toLowerCase() }}  </span>
          </div>
        </div>
        <div class="fx-row align-items-center justify-content-start">
          @if (executionOptions.length > 0) {
            <app-select [emitOnInit]="false" (change)="onExecutionChange($event)" class="mr-10"
                        [value]="filters.executionId"
                        [label]="'INTEGRATIONS.CRAWL_URLS.EXECUTION' | translate"
                        [options]="executionOptions"></app-select>
          }
          <app-select [emitOnInit]="false" initial="none" (change)="onStatusChange($event)" class="mr-10"
                      [label]="'INTEGRATIONS.CRAWL_URLS.STATUS' | translate"
                      [options]="statusSelectOptions"></app-select>
          <app-input placeholder="{{ 'ACTIONS.SEARCH' | translate }}..." type="text" prefix="search"
                     [(value)]="filters.query" (change)="onQueryChange()" style="width:210px;"></app-input>
        </div>
      </div>
      <mat-divider></mat-divider>
      <table mat-table [dataSource]="paginator.docs" style="z-index: 0;" matSort
             (matSortChange)="onSortChange($event)">

        <ng-container matColumnDef="url">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="small light bold">
            {{ 'INTEGRATIONS.CRAWL_URLS.URL' | translate }}
          </span>
          </th>
          <td mat-cell *matCellDef="let crawlUrl">
            <a target="_blank" [href]="crawlUrl.url" class="text bold">{{ crawlUrl.url }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="small light bold">
            {{ 'INTEGRATIONS.CRAWL_URLS.STATUS' | translate }}
          </span>
          </th>
          <td mat-cell *matCellDef="let crawlUrl">
            <div class="fx-row align-items-center justify-content-start">
              <span [class.green]="crawlUrl.status === 'success'"
                    [class.red]="crawlUrl.status === 'failed'"
                    class="chip light">{{
                  'INTEGRATIONS.CRAWL_URLS.STATUSES.' + crawlUrl.status | translate
                }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="document">
          <th mat-header-cell *matHeaderCellDef>
          <span class="small light bold">
            {{ 'INTEGRATIONS.CRAWL_URLS.DOCUMENT' | translate }}
          </span>
          </th>
          <td mat-cell *matCellDef="let crawlUrl">
            @if (documentRef(crawlUrl); as doc) {
              <a class="text bold clickable" (click)="openDocument(crawlUrl)">
                <mat-icon class="dark mr-5" style="transform:scale(0.8); vertical-align:middle;"
                          fontSet="material-icons-outlined">description</mat-icon>{{ doc.name }}
              </a>
            } @else {
              <span class="text light">-</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="error">
          <th mat-header-cell *matHeaderCellDef>
          <span class="small light bold">
            {{ 'INTEGRATIONS.CRAWL_URLS.ERROR' | translate }}
          </span>
          </th>
          <td mat-cell *matCellDef="let crawlUrl">
            @if (crawlUrl.status === 'failed' && crawlUrl.error) {
              <span class="text red ellipsis" [matTooltip]="crawlUrl.error"
                    [matTooltipClass]="{'uzai-tooltip':true}">{{ crawlUrl.error }}</span>
            } @else {
              <span class="text light">-</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="processedAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="small light bold">
            {{ 'INTEGRATIONS.CRAWL_URLS.PROCESSED_AT' | translate }}
          </span>
          </th>
          <td mat-cell *matCellDef="let crawlUrl">
            <div class="fx-row align-items-center justify-content-start">
              <time [dateTime]="crawlUrl.processedAt" class="text light">{{ date(crawlUrl.processedAt) }}</time>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let crawlUrl; columns: displayedColumns;"></tr>
      </table>
      @if (!loading && paginator.totalDocs === 0) {
        <div class="p-16">
          <span class="text light">{{ 'INTEGRATIONS.CRAWL_URLS.NO_URL_FOUND' | translate }}</span>
        </div>
      }
      <mat-paginator [length]="paginator.totalDocs || 0" [pageSize]="paginator.limit || 0"
                     [pageIndex]="paginator && paginator.page ? (paginator.page - 1) : 0"
                     [pageSizeOptions]="[10, 25, 50, 100]"
                     (page)="handlePage($event)">
      </mat-paginator>
    </mat-card>
    }
  }
</div>
